import { Routes } from '@angular/router';
import { ROUTES } from '@shared/constants/routes';

export const dashboardRoutes: Routes = [
  {
    path: ROUTES.PAYSLIPS_MANAGEMENT,
    loadComponent: () =>
      import('../../shared/payslips-management/payslips-management').then((m) => m.PayslipsManagement),
  },
  {
    path: ROUTES.TIME_TRACKING_MANAGEMENT,
    loadComponent: () =>
      import('../../shared/time-tracking-management/time-tracking-management').then((m) => m.TimeTrackingsManagement),
  },
  {
    path: ROUTES.DISPUTE_CENTER,
    loadComponent: () =>
      import('./dispute-center/dispute-center').then((m) => m.DisputeCenterEmployer)
  },
  {
    path: ROUTES.ARCHIVED_DOCUMENTS,
    loadComponent: () =>
      import('./archived-documents/archived-documents').then((m) => m.ArchivedDocuments)
  },
  {
    path: ROUTES.DISPUTE_CENTER_DETAIL,
    loadComponent: () =>
      import('./dispute-center/detail-ticket/detail-ticket').then((m) => m.DetailTicketEmployer)
  },
  {
    path: ROUTES.WHISTLEBLOWING,
    loadComponent: () =>
      import('./whistleblowing/whistleblowing').then((m) => m.Whistleblowing)
  },
  {
    path: ROUTES.WHISTLEBLOWING_DETAIL,
    loadComponent: () =>
      import('./whistleblowing/detail-whistleblowing/detail-whistleblowing').then((m) => m.DetailWhistleblowing)
  },
  {
    path: ROUTES.REFOUND,
    loadComponent: () =>
      import('./refound/refound').then((m) => m.RefoundComponent)
  },
  {
    path: ROUTES.ATTENDANCE_SHEET,
    loadComponent: () =>
      import('./attendance-sheet/attendance-sheet').then((m) => m.AttendanceSheetPage),
  },
  //   {
  //     path: 'attendance-sheet',
  //     loadComponent: () =>
  //       import('./attendance-sheet/attendance-sheet').then((m) => m.AttendanceSheetComponent),
  //   },
  //   {
  //     path: 'shift-management',
  //     loadComponent: () =>
  //       import('./shift-management/shift-management').then((m) => m.ShiftManagementComponent),
  //   },
  //  {
  //    path: 'sepa-direct-debit',
  //    loadComponent: () =>
  //      import('./sepa-direct-debit/sepa-direct-debit').then((m) => m.SepaDirectDebit),
  //  },
  //   {
  //     path: 'grens-invoicing',
  //     loadComponent: () =>
  //       import('./grens-invoicing/grens-invoicing').then((m) => m.GrensInvoicingComponent),
  //   },
  //   {
  //     path: 'invite-collaborators',
  //     loadComponent: () =>
  //       import('./invite-collaborators/invite-collaborators').then(
  //         (m) => m.InviteCollaboratorsComponent
  //       ),
  //   },
  //   {
  //     path: 'location-management',
  //     loadComponent: () =>
  //       import('./location-management/location-management').then(
  //         (m) => m.LocationManagementComponent
  //       ),
  //   },
  //   {
  //     path: 'dispute-center',
  //     loadComponent: () =>
  //       import('./dispute-center/dispute-center').then((m) => m.DisputeCenterComponent),
  //   },
];

export const dashboardRoutesEmployer: Routes = [
  {
    path: ROUTES.PAYSLIPS_MANAGEMENT,
    loadComponent: () =>
      import('../../shared/payslips-management/payslips-management').then((m) => m.PayslipsManagement),
  },
  {
    path: ROUTES.TIME_TRACKING_MANAGEMENT,
    loadComponent: () =>
      import('../../shared/time-tracking-management/time-tracking-management').then((m) => m.TimeTrackingsManagement),
  },
  {
    path: ROUTES.CONTRACT_MANAGEMENT,
    loadComponent: () =>
      import('../../employer/dashboard/employees-management/contract-management/contract-management').then((m) => m.ContractManagement),
  },
  {
    path: ROUTES.CONTRACT_MANAGEMENT_DETAIL,
    loadComponent: () =>
      import('../../employer/dashboard/employees-management/contract-management/detail-contract/detail-contract').then((m) => m.DetailContractEmployer),
  },
  {
    path: ROUTES.TIME_TRACKING_MANAGEMENT,
    loadComponent: () =>
      import('../../shared/time-tracking-management/time-tracking-management').then((m) => m.TimeTrackingsManagement),
  },
  {
    path: ROUTES.ATTENDANCE_SHEET,
    loadComponent: () =>
      import('../../employer/dashboard/employees-management/attendance-sheet/attendance-sheet').then((m) => m.AttendanceSheetPage),
  },
  {
    path: ROUTES.ATTENDANCE_SHEET_DETAIL,
    loadComponent: () =>
      import('../../../../shared/components/attendance-sheet/attendance-sheet-employee-row/attendance-sheet-detail/attendance-sheet-detail').then((m) => m.AttendanceSheetDetail),
  },
];